{
  "hero": {
    "title": "Preise"
  },
  "intro": {
    "title": "Schneller Service, faire Preise, hoher Mehrwert!",
    "subtitle": "Im Gegensatz zu größeren Agenturen biete ich eine einzigartige Kombination aus Erschwinglichkeit, persönlichem Service und Fachkompetenz in der Erstellung von Videos für moderne Plattformen."
  },
  "promo": {
    "discount": "-50%",
    "title": "FÜR DAS ERSTE UNTERNEHMENS- ODER RECRUITINGVIDEO",
    "location": "*DREHARBEITEN NUR IN MÜNCHEN, DEUTSCHLAND (+ 100KM) MÖGLICH.",
    "cta": "ICH BIN INTERESSIERT"
  },
  "tabs": {
    "subscription": "Abonnement",
    "perProject": "Pro Projekt"
  },
  "subscription": {
    "intro": "Engagieren Sie mich als Full-Stack-Videograf/Designer/Entwickler ohne vertragliche Bindung.",
    "packages": {
      "essential": {
        "title": "1. Essential-Paket",
        "prices": "10-15 Stunden/Monat (€700–€1.000/Monat)",
        "deliverables": "Leistungen:",
        "items": [
          "VIDEOGRAFIE: Kurzes Werbevideo, Unternehmens-/Recruiting-Videos, Social-Media-Paket und mehr",
          "GRAFIKDESIGN: Branding-Paket, Marketing und Werbung, Print-Design und mehr",
          "Reaktionszeit unter 24 Stunden"
        ]
      },
      "advanced": {
        "title": "2. Advanced-Paket",
        "prices": "20-30 Stunden/Monat (€1.500–€2.000/Monat)",
        "deliverables": "Leistungen:",
        "items": [
          "VIDEOGRAFIE: Werbevideo, Unternehmens-/Recruiting-Videos, Social-Media-Paket und mehr",
          "MOTION GRAPHICS: Individuelle Animationen, leichte Animationen, Sound-Design und mehr",
          "GRAFIKDESIGN: Branding-Paket, Marketing und Werbung, Print-Design und mehr",
          "UI/UX-DESIGN: Strategie, Website-Grafiken und Layouts, Benutzeroberflächen-Design und mehr",
          "Reaktionszeit unter 24 Stunden"
        ]
      },
      "elite": {
        "title": "3. Elite-Paket",
        "prices": "40-65 Stunden/Monat (€3.000–€4.500/Monat)",
        "deliverables": "Leistungen:",
        "items": [
          "VIDEOGRAFIE: Werbevideo, Unternehmens-/Recruiting-Videos, Social-Media-Paket und mehr",
          "MOTION GRAPHICS: Individuelle Animationen, leichte Animationen, Sound-Design und mehr",
          "GRAFIKDESIGN: Branding-Paket, Marketing und Werbung, Print-Design und mehr",
          "UI/UX-DESIGN: Strategie, Website-Grafiken und Layouts, Benutzeroberflächen-Design und mehr",
          "ENTWICKLUNG: Einfache Landing-Page-Entwicklung, Website-Wartung, komplette Website-Neugestaltung und mehr",
          "Reaktionszeit unter 8 Stunden"
        ]
      }
    }
  },
  "perProject": {
    "intro": "Flexibilität und maßgeschneiderte Lösungen für spezifische Ziele.",
    "video": {
      "title": "VIDEO",
      "items": {
        "promo": {
          "title": "Kurzes Werbevideo",
          "price": "Preisbereich: €500–€1.000",
          "features": [
            "Skript-Unterstützung.",
            "Dreh oder Bearbeitung von bereitgestelltem Material.",
            "Einfache Animationen oder Untertitel."
          ]
        },
        "corporate": {
          "title": "Unternehmens-/Recruiting-Videos",
          "price": "Preisbereich: €1.200–€2.500",
          "features": [
            "Vor-Ort-Dreh (1 Tag).",
            "Fortgeschrittene Bearbeitung und Motion Graphics.",
            "Individuelle Markengestaltung und Sprecheroptionen."
          ]
        },
        "social": {
          "title": "Social Media Paket (3 kurze Videos)",
          "price": "Preisbereich: €500–€1.000",
          "features": [
            "Kurze, ansprechende Inhalte für Plattformen wie Instagram, LinkedIn oder TikTok.",
            "Schnelle Umsetzung für trendbasiertes Marketing."
          ]
        }
      }
    },
    "graphicDesign": {
      "title": "GRAFIKDESIGN",
      "items": {
        "branding": {
          "title": "Branding-Paket",
          "price": "Preisbereich: €1.000–€1.500",
          "features": [
            "Logo-Design",
            "Visitenkarten",
            "2 Marketing-Materialien"
          ]
        },
        "marketing": {
          "title": "Marketing und Werbung",
          "price": "Preis: €70/Stunde",
          "features": [
            "Broschüren- und Flyer-Design",
            "Poster-Design",
            "Banner-Anzeigen (Web und Print)",
            "Social Media Grafiken",
            "E-Mail-Newsletter-Design"
          ]
        },
        "webDigital": {
          "title": "Web- und Digital-Design",
          "price": "Preis: €70/Stunde",
          "features": [
            "Website-Grafiken und Layouts",
            "Benutzeroberflächen (UI) Design",
            "App-Icon-Design",
            "Infografiken",
            "E-Book-Design"
          ]
        },
        "print": {
          "title": "Print-Design",
          "price": "Preis: €70/Stunde",
          "features": [
            "Magazin- und Zeitungslayouts",
            "Buchcover-Design",
            "Einladungen und Event-Karten",
            "Beschilderung und Werbetafeln",
            "Individuelle Illustrationen für den Druck"
          ]
        },
        "visualContent": {
          "title": "Visuelle Content-Erstellung",
          "price": "Preis: €70/Stunde",
          "features": [
            "Präsentationsdesign (z.B. PowerPoint, Keynote)",
            "Individuelle Illustrationen",
            "Icon-Design",
            "Social Media Grafiken",
            "Motion Graphics (z.B. animierte Logos)"
          ]
        },
        "specialized": {
          "title": "Spezialisierte Dienstleistungen",
          "price": "Preis: €70/Stunde",
          "features": [
            "Produkt-Mockups",
            "Messestands-Grafiken",
            "Menü-Design (z.B. für Restaurants)",
            "T-Shirt- und Bekleidungs-Design",
            "Fahrzeugbeklebung"
          ]
        }
      }
    },
    "development": {
      "title": "ENTWICKLUNG",
      "items": {
        "simpleLandingPage": {
          "title": "Einfache Landing-Page-Entwicklung",
          "price": "Preisbereich: €1.000–€2.000",
          "features": [
            "Mobilfreundliches Design, grundlegendes SEO und schnelle Lieferung"
          ]
        },
        "websiteMaintenance": {
          "title": "Website-Wartung",
          "price": "Preis: €50–€100/Stunde",
          "features": [
            "Für kleinere Aktualisierungen oder Korrekturen nach Bedarf."
          ]
        },
        "completeWebsiteRedesign": {
          "title": "Komplette Website-Neugestaltung",
          "price": "Preis: ab €3.000",
          "features": [
            "Vollständige Überarbeitung einer bestehenden Website, einschließlich Struktur, Branding und SEO-Optimierung."
          ]
        }
      }
    }
  },
  "modal": {
    "title": "-50% FÜR DAS ERSTE UNTERNEHMENS- ODER RECRUITINGVIDEO",
    "location": "*DREHARBEITEN NUR IN MÜNCHEN, DEUTSCHLAND (+ 100KM) MÖGLICH.",
    "howItWorks": {
      "title": "Wie funktioniert das?",
      "description": "Vielen Dank für Ihr Interesse an meinen Dienstleistungen. Nach einem kurzen Gespräch können Sie zwischen einem Unternehmensporträt oder einem Recruiting-Video (~30 Sekunden) wählen. Wir legen einen Termin fest, dann filme und bearbeite ich das Video.",
      "callout": "Perfekt für Social Media und Marketing — das ist Ihre Chance, die Qualität zu sehen, die ich in jedes Bild bringe. Ohne Verpflichtungen!"
    },
    "form": {
      "fullName": {
        "placeholder": "Vollständiger Name"
      },
      "email": {
        "placeholder": "E-Mail"
      },
      "submit": "Ich möchte es ausprobieren",
      "cancel": "Abbrechen"
    }
  }
}
